import EmptyPageIcon from '../../assets/icons/empty-page-icon.svg';

import styles from './EmptyPageSection.module.scss';

interface IEmptyPageSectionProp {
  title?: string | JSX.Element;
  className?: string;
}

const EmptyPageSection = ({ title, className }: IEmptyPageSectionProp) => {
  return (
    <div className={`${className} ${styles['wrapper']}`}>
      <div className={styles['content']}>
        <img src={EmptyPageIcon} className={styles['icon']} alt="The data section is empty" />
        {title && <p className={styles['caption']}>{title}</p>}
      </div>
    </div>
  );
};

export default EmptyPageSection;
